module.exports = __webpack_public_path__ + "img/bank-falabella.355c5192.png";